"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserBalanceDataForPayout = void 0;
class UserBalanceDataForPayout {
    userId;
    fullName;
    payoutType;
    payoutProblem;
    driversCompanyName;
    email;
    amount;
    debtAmount;
    penaltiesAmount;
    subsidiesAmount;
    compensationsAmount;
    assignationsWithDataForPayout;
    driverDebts;
    currency;
}
exports.UserBalanceDataForPayout = UserBalanceDataForPayout;
//# sourceMappingURL=UserBalanceDataForPayout.js.map